









import Vue from "vue";
import { computed, onMounted, onBeforeUnmount } from "@vue/composition-api";
import { onTouchOutside, onKey, $ } from "@/common/dom.functions";
import { emptyFn } from "../fp";
import { uniqueId } from "../utils/uniqueId";

enum PopupPosition {
  LEFT_TOP = "left-top",
  RIGHT_TOP = "right-top",
  BOTTOM_LEFT = "bottom-left",
  BOTTOM_RIGHT = "bottom-right",
  BOTTOM_CENTER = "bottom-center",
  CENTER_LEFT = "center-left",
  MANUAL = "manual",
}
export default Vue.extend({
  props: {
    position: {
      type: String,
      default: "manual",
    },
    name: {
      type: String,
      default: "",
    },
    trigger: {
      type: String,
      default: "",
    },
    alwaysClose: {
      type: Boolean,
      default: false,
    },
    detectEdges: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const popupId = uniqueId("app-popup");

    const shouldDetectEdges = computed(() => props.detectEdges as boolean);

    const onTouchOutsidePopup = onTouchOutside((ev?: MouseEvent) => {
      emit("outside", { name: props.name, ev });
      // @ts-ignore
      if (ev && ev.target && ev.target.dataset) {
        const { trigger } = (ev.target as HTMLElement).dataset;
        if (trigger && trigger === props.trigger) {
          ev.stopImmediatePropagation();
          ev.stopPropagation();
        }
      }
      return;
    });

    const subs = {
      touchOutside: emptyFn(),
      esc: emptyFn(),
    };

    const onEsc = onKey("Escape", false);

    const resizeToFitScreen = () => {
      const popupEl = document.querySelector(`#${popupId}`) as HTMLDivElement;
      const { bottom, height } = popupEl.getBoundingClientRect();
      const deltaBottom = bottom - innerHeight;
      if (deltaBottom > 0) {
        if (shouldDetectEdges.value) {
          popupEl.classList.remove("translate-y-full");
        } else {
          const toHeight = height - (deltaBottom + 10) + "px";
          popupEl.style.height = toHeight;
          (popupEl.children.item(0) as HTMLElement).style.height = toHeight;
        }
      }
    };

    onMounted(() => {
      emit("opened");
      subs.touchOutside = onTouchOutsidePopup(
        $(`#${popupId}`) as () => Element
      );

      subs.esc = onEsc(() => {
        emit("esc", { name: props.name });
      });
      resizeToFitScreen();
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
    });

    const positions = computed(() => {
      switch (props.position) {
        case PopupPosition.LEFT_TOP:
          return "left-0 top-0 -translate-x-full";
        case PopupPosition.RIGHT_TOP:
          return "right-0 top-0 translate-x-full";
        case PopupPosition.BOTTOM_RIGHT:
          return "bottom-0 right-0 translate-y-full";
        case PopupPosition.BOTTOM_LEFT:
          return "bottom-0 left-0 translate-y-full";
        case PopupPosition.BOTTOM_CENTER:
          return "bottom-0 left-50% translate-y-full -translate-x-1/2";
        case PopupPosition.CENTER_LEFT:
          return "bottom-0 left-0 translate-y-1/2 -translate-x-full";
        case PopupPosition.MANUAL:
        default:
          return "";
      }
    });

    return {
      popupId,
      positions,
    };
  },
});
